import { useAuthenticated } from "@gettactic/hooks";
import { MULTI_ROOM_RESERVATION_ENABLED } from "@/features/reserve/multiRoomReservation.config";

/**
 * Whether a reservation may hold several meeting rooms: the experimental master switch
 * AND the org having room bookings turned on (picking extra rooms is meaningless when
 * meeting rooms cannot be booked at all).
 */
export const useIsMultiRoomSelectionEnabled = (): boolean => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  return (
    MULTI_ROOM_RESERVATION_ENABLED &&
    !!authenticatedUser?.organization?.meeting_room_bookings_enabled
  );
};
